import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForStorageHardLimit(context: EditionAwarenessContextType): boolean {
	const {
		storageUsageInGB,
		storageLimitInGB,
		storageIsUnlimited,
		product,
		edition,
		billingSourceSystem,
		canDirectBuyUpgrade,
		isInCollection,
	} = context;

	if (!storageUsageInGB || !storageLimitInGB) {
		return false;
	}

	return (
		!isInCollection &&
		product === 'jira' &&
		edition === 'free' &&
		billingSourceSystem === 'CCP' &&
		!!canDirectBuyUpgrade &&
		!storageIsUnlimited &&
		storageUsageInGB >= storageLimitInGB
	);
}
